import React, {useRef, useState} from "react"
import productPageImg from "../../../../../assets/website-images/product/digital/digital-page-img.png"
import productBannerImg from "../../../../../assets/website-images/product/product-banner.jpg";
import {useInView} from "framer-motion";
import PageBanner from "../../../../components/website/pages-banner/PageBanner";
import {Col, Container, Row} from "react-bootstrap";
import sec1Img from "../../../../../assets/website-images/product/digital/sec-1-img.png";
import sec3Img from "../../../../../assets/website-images/product/digital/sec-3-img.png";
import sec2box1 from "../../../../../assets/website-images/product/digital/digital-boxs/b1.png";
import sec2box2 from "../../../../../assets/website-images/product/digital/digital-boxs/b2.png";
import sec2box3 from "../../../../../assets/website-images/product/digital/digital-boxs/b3.png";
import sec2box4 from "../../../../../assets/website-images/product/digital/digital-boxs/b4.png";
import sec2box5 from "../../../../../assets/website-images/product/digital/digital-boxs/b5.png";

import "./digital.scss"
import {useTranslation} from "react-i18next";

export default function DigitalPage() {
    const {t} = useTranslation();
    const ref3 = useRef(null);
    const ref = useRef(null);
    const isInView3 = useInView(ref3, { once: true });
    const isInView = useInView(ref, { once: true }); // Only trigger once
    const [activeSection, setActiveSection] = useState(1);
    const containerVariants2 = {
        hidden: { opacity: 1 },
        show: {
            opacity: 1,
            transition: {
                staggerChildren: 0.3, // Staggering the animation of each child by 0.3 seconds
            },
        },
    };
    const cardVariants = {
        hidden: { opacity: 0, x: -100 }, // Start with opacity 0 and 100px to the left
        show: { opacity: 1, x: 0 },      // Fade in and move to original position
    };


    const handleSectionClick = (sectionIndex) => {
        setActiveSection(sectionIndex);
    };

    return(
        <div className={'digital-page product-pages'}>
            <PageBanner img={productPageImg} heading={t('products.digital_identity.banner_head')} bannerImg={productBannerImg}/>
            <div className={'dig-section-1'}>
                <Container>
                    <Row>
                        <Col lg={6}>
                            <h3 className={'heading-h3'}>{t('products.digital_identity.section_1.head')}</h3>
                            <h5 className={'heading-h5'}>{t('products.digital_identity.section_1.sub_head')}</h5>
                            <p className={'para'}>{t('products.digital_identity.section_1.para')} </p>
                        </Col>
                        <Col lg={6} className={'text-center d-none d-md-block'}>
                            <img src={sec1Img} className={'img-fluid ms-auto'}/>
                        </Col>
                    </Row>
                </Container>
            </div>
            <div className={'dig-section-2'}>
                <Container>
                    <Row>
                        <Col lg={12} xl={4}>
                            <div className={'d-box'}>
                                <img src={sec2box1}/>
                                <h4 className={'heading-h4'}>{t('products.digital_identity.section_2.box_1.head')}</h4>
                                <p className={'para'}>{t('products.digital_identity.section_2.box_1.para')}</p>
                            </div>
                        </Col>
                        <Col lg={12} xl={4}>
                            <div className={'d-box'}>
                                <img src={sec2box2}/>
                                <h4 className={'heading-h4'}>{t('products.digital_identity.section_2.box_2.head')}</h4>
                                <p className={'para'}>{t('products.digital_identity.section_2.box_2.para')}</p>
                            </div>

                        </Col>
                        <Col lg={12} xl={4}>
                            <div className={'d-box'}>
                                <img src={sec2box3}/>
                                <h4 className={'heading-h4'}>{t('products.digital_identity.section_2.box_3.head')}</h4>
                                <p className={'para'}>{t('products.digital_identity.section_2.box_3.para')}</p>
                            </div>

                        </Col>
                        <Col lg={12} xl={4}>
                            <div className={'d-box'}>
                                <img src={sec2box4}/>
                                <h4 className={'heading-h4'}>{t('products.digital_identity.section_2.box_4.head')}</h4>
                                <p className={'para'}>{t('products.digital_identity.section_2.box_4.para')}</p>
                            </div>

                        </Col>
                        <Col lg={12} xl={4}>
                            <div className={'d-box'}>
                                <img src={sec2box5}/>
                                <h4 className={'heading-h4'}>{t('products.digital_identity.section_2.box_5.head')}</h4>
                                <p className={'para'}>{t('products.digital_identity.section_2.box_5.para')}</p>
                            </div>

                        </Col>
                    </Row>
                </Container>
            </div>
            <div className={'dig-section-3'}>
                <Container>
                    <Row className={'mb-5'}>
                        <Col md={12}>
                            <h2 className={'heading'}>{t('products.digital_identity.section_3.head')}</h2>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={6} className={'text-center'}>
                            <img src={sec3Img} className={'img-fluid ms-auto'}/>
                        </Col>
                        <Col lg={6}>
                            <p className={'para'} className={'mt-5'}> {t('products.digital_identity.section_3.para_1')} </p>
                            <p className={'para'}>{t('products.digital_identity.section_3.para_2')}</p>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    )
}